import { render, staticRenderFns } from "./YuboyaList.vue?vue&type=template&id=a0bfab32&"
import script from "./YuboyaList.vue?vue&type=script&lang=ts&"
export * from "./YuboyaList.vue?vue&type=script&lang=ts&"
import style0 from "./YuboyaList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports